import { render, staticRenderFns } from "./Popular.vue?vue&type=template&id=1935182c&"
import script from "./Popular.vue?vue&type=script&lang=ts&"
export * from "./Popular.vue?vue&type=script&lang=ts&"
import style0 from "./Popular.vue?vue&type=style&index=0&id=1935182c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports